import { render } from "./citation-search.vue?vue&type=template&id=3888fbf0&ts=true"
import script from "./citation-search.vue?vue&type=script&lang=ts"
export * from "./citation-search.vue?vue&type=script&lang=ts"

import "./citation-search.vue?vue&type=style&index=0&id=3888fbf0&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__